import { Snackbar, Alert as MuiAlert, IconButton, Slide } from '@mui/material';
import SuccessIcon from '@mui/icons-material/Done';
import ErrorIcon from '@mui/icons-material/ReportOutlined';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import WarningIcon from '@mui/icons-material/WarningAmberOutlined';
import CancelIcon from '@mui/icons-material/CancelOutlined';

const getAlertColor = (type) => {
    if (type === 'success') return 'rgb(35, 149, 139)';
    if (type === 'info') return 'rgb(41, 94, 172)';
    if (type === 'warning') return 'rgb(178, 105, 0)';
    return 'rgb(189, 30, 52)';
};

const getAlertIcon = (type) => {
    if (type === 'success') return <SuccessIcon fontSize="small" />;
    if (type === 'info') return <InfoIcon fontSize="small" />;
    if (type === 'warning') return <WarningIcon fontSize="small" />;
    if (type === 'error') return <ErrorIcon fontSize="small" />;
    return null;
};

const Alert = ({ type, position, message, open, close, onClick }) => (
    <Snackbar
        sx={{
            '& .MuiPaper-root': {
                backgroundColor: getAlertColor(type),
                color: 'white',
                borderRadius: '8px',
                boxShadow: '0 12px 30px rgba(0, 0, 0, 0.26)',
                maxWidth: 'min(720px, calc(100vw - 32px))',
                alignItems: 'flex-start',
                cursor: onClick ? 'pointer' : 'default',
            },
            '& .MuiAlert-message': {
                color: 'white',
                fontSize: '14px',
                fontWeight: 600,
                lineHeight: 1.45,
                whiteSpace: 'pre-line',
                overflowWrap: 'anywhere',
                padding: '2px 0',
            },
            '& .MuiAlert-icon': {
                color: 'white',
                paddingTop: '2px',
            },
            '& .MuiAlert-action': {
                paddingTop: 0,
            },
        }} anchorOrigin={{ vertical: 'top', horizontal: position }}
        autoHideDuration={type === 'error' ? 8000 : 5000}
        open={open}
        onClose={close}
        TransitionComponent={Slide}
        TransitionProps={{ direction: position === 'left' ? 'right' : 'left' }}
        transitionDuration={400}
    >
        <MuiAlert
            icon={getAlertIcon(type)}
            onClick={onClick}
            action={
                <IconButton
                    onClick={(event) => {
                        event.stopPropagation();
                        close(event);
                    }}
                    size="small"
                    aria-label="Close alert"
                    sx={{ color: 'white' }}
                >
                    <CancelIcon fontSize="small" />
                </IconButton>
            }
        >
            {message}
        </MuiAlert>
    </Snackbar>
);

export default Alert;
